<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">
        <!--コンテンツ-->
        <main id="renew2_mypage">
            <div class="top_container renew2_pc">
                <div class="renew2_wrapper renew2_flex">
                    <div class="servicelist">
                        <ul class="servicelist__block">
                            <li class="servicelist__item onclick"><a href="/kr/resume/mypage"><img
                                        src="/kr/resume/static/renew2_img/icon_mypagetop.svg" alt="마이페이지"><br>마이페이지</a>
                            </li>
                            <li v-if="false" class="servicelist__item waiting"><a
                                    href="/kr/resume/mypage/quickemail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickemail.svg" alt="야기메일"><br>야기메일</a>
                            </li>
                        </ul>
                    </div>
                    <div class="mypage_contents">
                        <h2>마이페이지</h2>
                        <p>마이페이지가 새로워졌어요.데이터 백업 및 복구 기능을 이용하려면<a href="/kr/resume/oldmypage"
                                style="color:#ff0000;text-decoration:underline; text-decoration-color:#FF0000;">구 마이페이지
                            </a>에 접속해 주세요.</p>
                        <div class="renew2_flex mypage_contents__01">
                            <div class="member_info">
                                <div class="renew2_flex member_info__block">
                                    <div>
                                        <p class="member_name"><span class="member_name_big">{{ username }}</span>님<br>
                                            <span v-if="useremail" class="member_name_mail">({{ useremail }})</span>
                                        </p>
                                        <ul>
                                            <li><a href="/kr/resume/mypage/basicinfo">메일변경</a></li>
                                            <li v-if="$site.appFlag != 'b'"><a href="/kr/resume/account/delete">기타설정</a>
                                            </li>
                                            <li v-else><a href="/kr/resume/account/delete">탈퇴 및 기타설정</a></li>
                                        </ul>
                                    </div>
                                    <!--登録メールアドレス＝会員名前-->
                                    <div class="yagi_info" v-if="$firebase.user.emailVerified">

                                        <your-yagi :your-yagi-class="{}"
                                            :yagi-options="{ dialogEnabled: true, rubyEnabled: false, messageEnabled: true }"></your-yagi>
                                        <!-- <img src="https://placehold.jp/150x150.png" alt="あなたのヤギ" class="yagi_img"> -->
                                        <p class="yagi_title">댱싱의야기</p>
                                    </div>
                                    <div class="yagi_info" v-else>
                                        메일 미확인상태
                                        <button type="button" class="el-button el-button--success joblist-btn"
                                            @click="sendEmailVerification"
                                            id="send-mynabi-pdf"><!----><!----><span>확인메일전송</span></button>
                                    </div>
                                </div>

                            </div>
                            <div class="contents_left">
                                <div class="sakusei_history">
                                    <h3>서식의 사용내역</h3>
                                    <ul v-if="mypagedata && mypagedata.format_ids">
                                        <li v-for="(item, index) in mypagedata.format_ids" :key="index"><a
                                                :href="'/format/' + item.format_id">{{ getFormatName(item.format_id)
                                                }}</a>
                                        </li>
                                    </ul>
                                    <p v-else>사용내역이 없습니다.</p>
                                </div>
                            </div>

                        </div>
                        <div class="renew2_flex mypage_contents__02">
                            <div class="jobsupport_recommend" v-if="false">
                                <h3>야기슈추천</h3>
                                <div class="jobsupport_recommend__block">
                                    <div class="jobsupport_recommend__logoimg"><img
                                            src="/kr/resume/static/renew2_img/recommendlogoimage.png" alt=""></div>
                                    <ul class="jobsupport_recommend__terms">
                                        <li>Yagish의<a href="">이용약관</a>、<a href="">개인정보보호방침</a></li>
                                        <li>아아아의<a href="">이용약관</a>、<a href="">개인정보보호방침</a></li>
                                    </ul>
                                    <p class="jobsupport_recommend__check">약관에 동의하여 무료상담신청</p>
                                    <button class="jobsupport_recommend__btn">신청</button>
                                </div>
                            </div>
                        </div>
                        <div class="out_block">
                            <a href="#" @click="$firebase.signOut(); $event.preventDefault()" class="out_btn">로그아웃</a>
                        </div>
                    </div>
                </div>
            </div>

            <!--SP-->
            <div class="top_container renew2_sp">
                <div class="renew2_wrapper">
                    <h2>마이페이지</h2>
                    <p>마이페이지가 새로워졌어요.데이터 백업 및 복구 기능을 이용하려면<a href="/kr/resume/oldmypage"
                            style="color:#ff0000;text-decoration:underline; text-decoration-color:#FF0000;">구마이페이지</a>로
                        접속해주세요。</p>
                    <div class="member_info renew2_sp_flex">
                        <div>
                            <p class="member_name"><span>{{ username }}</span>님</p><!--登録メールアドレス＝会員名前-->
                            <ul>
                                <li><a href="/kr/resume/mypage/basicinfo">메일주소변경</a></li>
                                <li v-if="$site.appFlag != 'b'"><a href="/kr/resume/account/delete">기타설정</a></li>
                                <li v-else><a href="/kr/resume/account/delete">탈퇴 및 기타설정</a></li>
                            </ul>
                        </div>
                        <div class="yagi_info" v-if="$firebase.user.emailVerified">
                            <your-yagi :your-yagi-class="{}"
                                :yagi-options="{ dialogEnabled: true, rubyEnabled: false, messageEnabled: true }"></your-yagi>
                            <p class="yagi_title">당신의 야기</p>
                        </div>
                        <div class="yagi_info" v-else>
                            메일 미확인상태
                            <button type="button" class="el-button el-button--success joblist-btn"
                                @click="sendEmailVerification"
                                id="send-mynabi-pdf"><!----><!----><span>확인메일전송</span></button>
                        </div>
                    </div>
                    <div class="sakusei_history">
                        <h3>서식의 사용내역</h3>
                        <ul v-if="mypagedata && mypagedata.format_ids">
                            <li v-for="(item, index) in mypagedata.format_ids" :key="index"><a
                                    :href="'/format/' + item.format_id">{{ getFormatName(item.format_id) }}</a></li>
                        </ul>
                        <p v-else>사용내역이 없습니다.</p>
                    </div>
                    <div class="servicelist" v-if="false">
                        <h3>各種サービスのご利用状況</h3>
                        <ul class="renew2_sp_flex servicelist__block">
                            <li><a href="/kr/resume/mypage/quickemail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickemail.svg" alt="야기메일"><br>야기메일</a>
                            </li>
                        </ul>
                    </div>
                    <div class="out_block">
                        <a href="#" @click="$firebase.signOut(); $event.preventDefault()" class="out_btn">로그아웃</a>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
/* @import url("//unpkg.com/element-ui@2.15.13/lib/theme-chalk/index.css"); */
</style>

<style scoped></style>



<script>
import {
    TabPane,
    Tabs,
    MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
    components: {
        'el-tabs': Tabs,
        'el-tab-pane': TabPane,
        'login-forms': LoginForms,
        Slick
    },
    data: function () {
        return {
            fullscreenLoading: true,
            recentEdit: {
                FormatId: ''
            },
            introData: {},
            backupList: {
                auto: [],
                user: []
            },
            dialogVisible: false,
            username: '',
            useremail: '',
            selectedYagiOfferData: {},
            selectedQuickEmailData: {},
            mypagedata: [],
            quickemailList: [],
            qmail_rirekisho_html: '',
            qmail_shokumukeirekisho_html: '',
            joblistKeyword: '',
            joblistArea: '',
            backupListLoaded: {
                auto: false,
                user: false
            },
            slickOptions: {
                accessibility: true,
                autoplay: true,
                autoplaySpeed: 2400,
                speed: 400
            },
            saved: false,
            recomm_code: '',
            saveLabel: '',
            backupDataToConfirm: null,
            previewScale: 1,
            previewQEmailScale: 1,
            backupDataViewerCssRirekisho: {},
            backupDataViewerCssShokurekisho: {},
            qmailViewerCssRirekisho: {},
            qmailViewerCssShokurekisho: {},
            deleteBackupPopoverVisible: false,
            previewLoading: false,
            rirekisho_height: 110,
            keirekisho_height: 110,
            previewQEmailLoading: false,
            activeTabName: 'user',
            activePreviewTab: 'format_rirekisho',
            activeQEmailPreviewTab: 'format_rirekisho'
        }
    },
    computed: {
        getMode: function () {
            return process.env.VUE_APP_MODE
        }
    },
    methods: {
        getFormatName: function (format_id) {
            for (let p of this.$site.formatsIndex) {
                if (p.id == format_id) {
                    return p.title
                }
            }
            for (let p of this.$site.keirekishoFormatsIndex) {
                if (p.id == format_id) {
                    return p.title
                }
            }
            return '-'
        },
        clickJob: async function () {
            if (!this.$deviceLib.isOnline) {
                this.$message({
                    message: '현재 오프라인입니다.인터넷 연결 후 다시 시도해 보세요.',
                    type: 'warning'
                })
                return
            }

            const formData = new FormData()
            formData.append('uuid', this.$firebase.user.uid)
            formData.append('format_id', 'mypage')
            formData.append('keyword', this.joblistKeyword)
            formData.append('area', this.joblistArea)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('version', '2')
            formData.append('site_flag', 'c')
            formData.append('app_flag', this.$site.appFlag)

            const app = this
            this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, { timeout: 60000 })
        },
        sendEmailVerification: async function () {
            const app = this
            await this.$firebase.user.sendEmailVerification().then(() => {
                app.$message({
                    message: '전송하였습니다. 메일내의 링크를 클릭해 주세요.',
                    type: 'success'
                })

            }).catch((error) => {
                app.$message({
                    message: '전송실패。',
                    type: 'error'
                })
            })
        }
    },
    created: function () {

        const app = this


        // console.log(this.$route.query.mynavi)
        firebase.auth().onAuthStateChanged((user) => {
            console.log('mypage onAuthStateChanged')
            if (user) {
                console.log('mypage logined')
                const formData = new FormData()
                formData.append('uuid', user.uid)
                formData.append('version', '2')
                formData.append('reqflg', '2')
                formData.append('email', user.email)
                formData.append('site_flag', 'c')
                formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
                formData.append('email_verified', user.emailVerified ? '1' : '0')

                app.$axios
                    .post(app.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
                    .then(function (response) {
                        app.mypagedata = response.data
                        if (app.$firebase.user.displayName) {
                            app.username = app.$firebase.user.displayName
                            app.useremail = app.$firebase.user.email
                        } else if (app.mypagedata.memberdata.lastname) {
                            app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
                            app.useremail = app.$firebase.user.email
                        } else {
                            app.username = app.$firebase.user.email
                        }
                        app.joblistKeyword = app.mypagedata.memberdata.keyword
                        app.joblistArea = app.mypagedata.memberdata.area
                    })
                    .catch(function (error) {
                        if (app.$firebase.user.displayName) {
                            app.username = app.$firebase.user.displayName
                            app.useremail = app.$firebase.user.email
                        } else {
                            app.username = app.$firebase.user.email
                        }
                    }).finally(function () {
                    })
                app.fullscreenLoading = false

            } else {
                console.log('mypage login')
                app.$router.push('/login')
            }
        })
    },
    beforeMount: function () {
    },
    destroyed: function () {
    }
}
</script>
